import Masonry from "masonry-layout";

export default () => {
  const tiles = [...document.getElementsByClassName("js-tile")];

  tiles.forEach((element) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const msnry = new Masonry(element, {
      // options...
      itemSelector: ".grid-item",
      columnWidth: ".grid-sizer",
      percentPosition: true,
    });
  });
};
